import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from 'react-collapse';
import { IoIosArrowDown } from "react-icons/io";
import logo_topo from './../../assets/logo-texto-topo.png';
import './styles.css';
//var _id = localStorage.getItem("id_agent");

var Ps_ID = localStorage.getItem("professional_id");
var RI_ID = localStorage.getItem("id_agent");
const drawerWidth = 320;
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: "#ffffff"
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(1),
        color: "#184C86"
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    OG_ItemText: {
        marginLeft: -30,
    },
    RI_ItemText: {
        marginLeft: -30,
    },
    PS_ItemText: {
        marginLeft: -30,
    },
    PS_Estudante_ItemText: {
        marginLeft: -30,
    },
    PS_Tutor_ItemText: {
        marginLeft: -30,
    },
    PS_Especialista_ItemText: {
        marginLeft: -30,
    },
    collapsed: {
        paddingLeft: 50
    },
    ListItem: {
        marginLeft: -20
    }
}));

export default function PersistentDrawerLeft() {
    let [organizador, setOrganizador] = useState(false);
    let [RI, setRI] = useState(false);
    let [PS, setPS] = useState(false)
    let [RC, setRC] = useState(false);
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <NavLink to="/"><img id="logo-topo-Side-Nav" src={logo_topo} alt="logo" /></NavLink>
                </Toolbar>
            </AppBar>
            <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    <ListItem >
                        <ListItemIcon onClick={() => setRC(!RC)}>< IoIosArrowDown id="Arrow-Down-Side_Nav" /> </ListItemIcon>
                        <ListItemText className={classes.OG_ItemText} ><p id="Title-Side-Nav-RC">Sobre a Rede Convida</p></ListItemText>
                    </ListItem>
                    <div className={classes.collapsed}>
                        <Collapse isOpened={RC} >
                            <ListItem  >
                                <ListItemText><a href="/Tela_Conheca"><p id="screens-Side-Nav-OG">Conheça o Projeto</p></a></ListItemText>
                            </ListItem>
                            <ListItem  >
                                <ListItemText><NavLink to="/Tela_Manual"><p id="screens-Side-Nav-OG">Tutorial de Uso</p></NavLink></ListItemText>
                            </ListItem>
                        </Collapse>
                    </div>


                    <ListItem >
                        <ListItemIcon onClick={() => setOrganizador(!organizador)}>< IoIosArrowDown id="Arrow-Down-Side_Nav" /> </ListItemIcon>
                        <ListItemText className={classes.OG_ItemText} ><p id="Title-Side-Nav-OG">Organizador</p></ListItemText>
                    </ListItem>
                    <div className={classes.collapsed}>
                        <Collapse isOpened={organizador} >
                            <ListItem  >
                                <ListItemText><NavLink to="/Tela_Login_Organizador"><p id="screens-Side-Nav-OG">Login</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem  >
                                <ListItemText><NavLink to="/Tela_OG"><p id="screens-Side-Nav-OG">Painel de Controle</p></NavLink></ListItemText>
                            </ListItem>
                        </Collapse>
                    </div>
                    <ListItem >
                        <ListItemIcon onClick={() => setRI(!RI)}><IoIosArrowDown id="Arrow-Down-Side_Nav" /> </ListItemIcon>
                        <ListItemText className={classes.RI_ItemText}><p id="Title-Side-Nav-RI">Representante de instituição</p></ListItemText>
                    </ListItem>
                    <div className={classes.collapsed}>
                        <Collapse isOpened={RI} >
                            <ListItem>
                                <ListItemText><NavLink to="/RI_Cadastro"><p id="screens-Side-Nav-RI">Cadastro</p></NavLink></ListItemText>
                            </ListItem>

                            <ListItem>
                                <ListItemText><NavLink to="/RI_Login"><p id="screens-Side-Nav-RI">Login</p></NavLink></ListItemText>
                            </ListItem>
                            {RI_ID != null ?
                                <ListItem  >
                                    <ListItemText><NavLink to={{pathname:"RI_Perfil/" + RI_ID}}><p id="screens-Side-Nav-OG">Perfil</p></NavLink></ListItemText>
                                </ListItem>
                                : null}
                            <ListItem>
                                <ListItemText><NavLink to="/RI_Painel"><p id="screens-Side-Nav-RI">Painel de controle</p></NavLink></ListItemText>
                            </ListItem>
                        </Collapse>
                    </div>
                    <ListItem >
                        <ListItemIcon onClick={() => setPS(!PS)}><IoIosArrowDown id="Arrow-Down-Side_Nav" /> </ListItemIcon>
                        <ListItemText className={classes.PS_ItemText}><NavLink to="/Tela_PS"><p id="Title-Side-Nav-PS">Profissional de saúde</p></NavLink></ListItemText>
                    </ListItem>
                    <div className={classes.collapsed}>
                        <Collapse isOpened={PS} >
                            <ListItem>
                                <ListItemText><NavLink to="/login_m"><p id="screens-Side-Nav-PS">Login</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/tela_ps_cadastro"><p id="screens-Side-Nav-PS">Cadastro</p></NavLink></ListItemText>
                            </ListItem>
                            
                            {Ps_ID != null ?
                                <ListItem>
                                    <ListItemText><NavLink to={{ pathname: "/tela_ps_perfil/" + Ps_ID }}><p id="screens-Side-Nav-PS">Perfil</p></NavLink></ListItemText>
                                </ListItem> : null}
                            
                            <ListItem>
                                <ListItemText className={classes.PS_Tutor_ItemText}><NavLink to="/"><p id="Title-Side-Nav-PS-subtitle-Tutor">Médico Tutor</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Tutor">Painel de Controle</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText className={classes.PS_Especialista_ItemText}><NavLink to="/tela_ps_painel"><p id="Title-Side-Nav-PS">Profissional da Saúde</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/tela_ps_painel"><p id="screens-Side-Nav-PS-Especialista">Painel de Controle</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText className={classes.PS_Estudante_ItemText}><NavLink to="/"><p id="Title-Side-Nav-PS-subtitle-Estudante">Estudante</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Estudante">Painel de Controle</p></NavLink></ListItemText>
                            </ListItem>
                        </Collapse>
                    </div>
                </List>
            </Drawer>
        </div>
    );
}
